import { Component, Element, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'zpr-navbar-mobile-dropdown',
  styleUrl: 'navbar-mobile-dropdown.scss',
})

export class ZprNavbar {
  @Element() el: HTMLElement;

  componentDidLoad() {
    this.init()
  }

  init() {
    this.onSubmenuDropdownClick()
  }

  onSubmenuDropdownClick() {
    let btnEls = this.el.querySelectorAll('.open-button')
    let backButtonEls = this.el.querySelectorAll('.back-button')

      for (let i = 0; i < btnEls.length; i++) {
        let btnEl = btnEls[i] as HTMLElement
        btnEl.addEventListener('click', (ev) => {
          ev.preventDefault()
          let dropdownEl = btnEl.closest('.submenu-dropdown') as HTMLElement
          dropdownEl.classList.add('active')
        })
      }
      for (let i = 0; i < backButtonEls.length; i++) {
        let backButtonEl = backButtonEls[i] as HTMLElement
        backButtonEl.addEventListener('click', (ev) => {
          ev.preventDefault()
          let dropdownEl = backButtonEl.closest('.submenu-dropdown') as HTMLElement
          dropdownEl.classList.remove('active')
        })
      }

  }

  render() {
    return (
      <Host>
        <zpr-dropdown>
          <button type="button" class="btn navbar-bottom-icon d-hide" aria-label="Main menu" slot="toggle">
            <div class="navbar-icon-line"></div>
            <div class="navbar-icon-line"></div>
            <div class="navbar-icon-line"></div>
          </button>
          <slot name="body"></slot>
        </zpr-dropdown>
      </Host>
    )
  }
}